// extracted by mini-css-extract-plugin
export default {"checkGroup":"checkGroup__1f9b2d82","stacked":"stacked__1f9b2d82","cb":"cb__1f9b2d82","label":"label__1f9b2d82"};